import { User } from './auth.types'; 
export enum AuditActionType {
    CREATE = 'create',
    READ = 'read',
    UPDATE = 'update',
    DELETE = 'delete',
    LOGIN = 'login',
    LOGOUT = 'logout',
    TRANSFER = 'transfer',
  }
  
  
  export interface AuditLog {
    id: string;
    action: AuditActionType;
    entityType?: string;
    entityId?: string;
    details?: Record<string, any>;
    ipAddress?: string;
    createdAt: string;
    userId: string;
    user?: User ;
  }
  
  export interface AuditLogQuery {
    userId?: string;
    actions?: AuditActionType[];
    entityType?: string;
    entityId?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
  }
  
  export interface AuditLogResponse {
    data: AuditLog[];
    total: number;
    page: number;
    pageSize: number;
  }